import { Component, OnInit, ViewChild, ElementRef, Input, ChangeDetectorRef, Output, EventEmitter } from '@angular/core';
import { IonRangeSliderOptions, IonRangeSliderEvent } from 'ion-rangeslider';

import * as _ from 'lodash';

declare var MediaRecorder: any;

@Component({
    selector: 'video-trimmer',
    template: require('./video-trimmer.component.html'),
    //   styles: [require('./video-trimmer.component.scss')]
})
export class VideoTrimmerComponent implements OnInit {

    private mediaSource = new MediaSource();
    private stream;
    private mediaRecorder;
    private recordedBlobs;
    private sourceBuffer;
    private superBuffer;


    enableRecord = false;

    @ViewChild('video') video: ElementRef;
    //   @ViewChild('video') video:ElementRef<HTMLVideoElement>;
    //@ViewChild('video2') video2:ElementRef<HTMLVideoElement>;

    @Input('source') source: string;
    @Input('maxDuration') maxDuration: number = 10;

    @Output('base64') base64: EventEmitter<any> = new EventEmitter();

    private rangeSliderConf: IonRangeSliderOptions;
    private rangeTrim: { from?: number; to?: number; } = {};

    duration = 0;

    constructor(
        private cdr: ChangeDetectorRef
    ) {

    }

    get videoEl(): HTMLVideoElement {
        return this.video.nativeElement;
    }

    ngOnInit() {
        this.mediaSource.addEventListener('sourceopen', this.handleSourceOpen, false);
        this.video.nativeElement.ontimeupdate = () => {
            const { from, to } = this.rangeTrim;
            console.log("current", this.video.nativeElement.currentTime, `range: ${from} - ${to}`);
            if (to && this.video.nativeElement.currentTime >= to) {
                this.video.nativeElement.pause();
                if (this.enableRecord) {
                    this.stopRecording();
                    this.enableRecord = false;
                    this.cdr.detectChanges();
                }
            }
        }
        window['video'] = this.video;
        this.videoEl.onloadeddata = () => {
            // console.log("dectectChanges", this.video.nativeElement.duration);
            this.duration = this.video.nativeElement.duration;
            this.rangeSliderConf = {
                min: 0,
                max: _.cloneDeep(this.duration),
                from: 0,
                to: this.maxDuration,
                step: 0.01,
                max_interval: this.maxDuration,
                prettify: (n) => {
                    const padFn = (v) => (String(v) as any).padStart(2, '0');
                    const hh = Math.floor(n / 3600), mm = Math.floor((n % 3600) / 60), ss = Math.floor((n % 3600) % 60);
                    if (hh === 0) {
                        return `${mm}:${padFn(ss)}`;
                    }
                    return `${padFn(hh)}:${padFn(mm)}:${padFn(ss)}`;
                }
            }
            this.cdr.detectChanges();
        }



    }

    play() {
        this.video.nativeElement.currentTime = this.rangeTrim.from;
        this.video.nativeElement.play();
        if (this.enableRecord) {
            this.startRecording();
        }
    }

    trimVideo() {
        this.enableRecord = true;
        this.play();
    }

    onRangeChange($event: IonRangeSliderEvent) {
        this.videoEl.currentTime = $event.from;
        this.rangeTrim = _.pick($event, ['from', 'to']);
    }

    handleSourceOpen() {
        // this.sourceBuffer = this.mediaSource.addSourceBuffer('video/webm; codecs="vp8"');
        this.sourceBuffer = this.mediaSource.addSourceBuffer('video/webm');
    }

    handleDataAvailable(event) {
        if (event.data && event.data.size > 0) {
            this.recordedBlobs.push(event.data);
        }
    }

    handleStop(event) {
        console.log('Recorder stopped: ', event);
        this.superBuffer = new Blob(this.recordedBlobs, { type: 'video/webm' });

        // this.video.nativeElement.src = window.URL.createObjectURL(this.superBuffer);
        const reader = new FileReader();
        reader.readAsDataURL(this.superBuffer);
        reader.onloadend = () => {
            const base64data = _.cloneDeep(reader.result);
            const file: File = (() => {
                const binary = atob((base64data as string).split(',')[1]), data = [];
                for (let i = 0; i < binary.length; i++) {
                    data.push(binary.charCodeAt(i));
                }
                return new File([new Uint8Array(data)], `video-trimmed-${_.now()}.webm`, { type: 'video/webm' });
            })();
            this.base64.emit([base64data, file]);
        }

    }

    startRecording() {
        let options: { mimeType: string, videoBitsPerSecond?: number } = { mimeType: 'video/webm' };
        this.recordedBlobs = [];
        if ((<any>this.video.nativeElement).captureStream) {
            this.stream = (<any>this.video.nativeElement).captureStream();
        } else if ((<any>this.video.nativeElement).mozCaptureStream) {
            this.stream = (<any>this.video.nativeElement).mozCaptureStream();
        }
        try {
            this.mediaRecorder = new MediaRecorder(this.stream, options);
        } catch (e0) {
            console.log('Unable to create MediaRecorder with options Object: ', e0);
            try {
                options = { mimeType: 'video/webm,codecs=vp9' };
                this.mediaRecorder = new MediaRecorder(this.stream, options);
            } catch (e1) {
                console.log('Unable to create MediaRecorder with options Object: ', e1);
                try {
                    options = <any>'video/vp8'; // Chrome 47
                    this.mediaRecorder = new MediaRecorder(this.stream, options);
                } catch (e2) {
                    // alert('MediaRecorder is not supported by this browser.\n\n' +
                    //     'Try Firefox 29 or later, or Chrome 47 or later, ' +
                    //     'with Enable experimental Web Platform features enabled from chrome://flags.');
                    console.error('Exception while creating MediaRecorder:', e2);
                    return;
                }
            }
        }
        console.log('Created MediaRecorder', this.mediaRecorder, 'with options', options);
        this.mediaRecorder.onstop = (event) => {
            this.handleStop(event);
        };
        this.mediaRecorder.ondataavailable = (event) => {
            this.handleDataAvailable(event);
        };
        this.mediaRecorder.start(100); // collect 100ms of data
        console.log('MediaRecorder started', this.mediaRecorder);
    }

    stopRecording() {
        this.mediaRecorder.stop();
        console.log('Recorded Blobs: ', this.recordedBlobs);
        //this.video2.nativeElement.controls = true;
    }

}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/common/utils/video-trimer.component.ts